import $ from 'jquery';
import Hammer from 'hammerjs';
import PubSub from 'Utils/pub-sub';
import BreakpointDispatcher from 'Utils/breakpoint-dispatcher';

export default class Slider {

  constructor(el) {
    BreakpointDispatcher.start();
    let self = this;

    this.slider = el;
    this.pane = el.find('.js-slider-pane');
    this.paneItems = el.find('.js-slider-item');
    this.prevBtn = el.find('.js-slider-prev');
    this.nextBtn = el.find('.js-slider-next');
    this.dots = el.find('.js-slider-dot');
    this.hammerEvent = new Hammer(el[0]);

    this.dir = {
      LEFT: 1,
      RIGHT: -1
    };

    this.MOBILE_ITEMS = 1;
    this.DESKTOP_ITEMS = this.getNumOfItems();

    this.index = 0;
    this.prevItems = 0;
    this.nextItems = this.paneItems.length - this.getNumOfVisibleItems();

    this.init();
  }

  init() {
    let self = this;

    PubSub.subscribe('resize:desktop', function () {
      self.resetPositions();
    });

    PubSub.subscribe('resize:tablet', function () {
      self.resetPositions();
    });

    PubSub.subscribe('resize:mobile', function () {
      self.resetPositions();
    });

    this.setArrowState();
    this.handleArrowClick(self);
    this.handleSwipe(self);
  }

  getNumOfItems() {
    let numOfItems = this.slider.attr('data-slider-items');
    
    if (numOfItems) {
      return Number(numOfItems);
    }
    
    return 3;
  }

  resetPositions() {
    this.index = 0;
    this.prevItems = 0;
    this.nextItems = this.paneItems.length - this.getNumOfVisibleItems();
    this.applyTransformation(0);
    this.setArrowState();
    this.updateDot();
  }

  handleArrowClick(self) {
    this.nextBtn.click(function () {
      self.slidePane(
        self.getNextItems(), self.dir.LEFT
      );
    });
    
    this.prevBtn.click(function () {
      self.slidePane(
        self.getPrevItems(), self.dir.RIGHT
      );
    });
  }

  handleSwipe(self) {
    this.hammerEvent.on('swipe', function (e) {
      if (e.deltaX < 0) {
        self.slidePane(
          self.getNextItems(), self.dir.LEFT
        );
      } else {
        self.slidePane(
          self.getPrevItems(), self.dir.RIGHT
        );
      }
    });
  }
  
  slidePane(value, direction) {
    this.update(value, direction);

    this.applyTransformation(
      this.getTranslationValue()
    );

    this.setArrowState();
    this.updateDot();
  }

  setArrowState() {
    if (this.nextItems === 0) {
      this.nextBtn.addClass('is-hidden');
    } else {
      this.nextBtn.removeClass('is-hidden');
    }

    if (this.prevItems === 0) {
      this.prevBtn.addClass('is-hidden');
    } else {
      this.prevBtn.removeClass('is-hidden');
    }
  }

  applyTransformation(value) {
    this.pane.css(
      'transform',
      'translate3d('+ value + '%, 0, 0)'
    );
  }

  update(value, direction) {
    this.nextItems -= (value * direction);
    this.prevItems += (value * direction);
    this.index += (value * direction);
  }

  updateDot() {
    this.dots.filter('.is-active').removeClass('is-active');
    this.dots.eq(this.index).addClass('is-active');
  }

  getNextItems() {
    return this.clamp(
      this.nextItems, 0, this.getNumOfVisibleItems()
    );
  }

  getPrevItems() {
    return this.clamp(
      this.prevItems, 0, this.getNumOfVisibleItems()
    );
  }

  getNumOfVisibleItems() {
    let windowSize = $(window).width();

    if (windowSize < 768) {
      return this.MOBILE_ITEMS;
    }

    else if (windowSize <= 1024) {
      return this.DESKTOP_ITEMS - 1;
    }

    else if (windowSize > 1024) {
      return this.DESKTOP_ITEMS;
    }
  }

  getTranslationValue() {
    let windowSize = $(window).width();

    if (windowSize < 768) {
      return (this.index * -90) / this.MOBILE_ITEMS;
    }

    else if (windowSize <= 1024) {
      return (this.index * -(46*(this.DESKTOP_ITEMS - 1))) / (this.DESKTOP_ITEMS - 1);
    }

    else if (windowSize > 1024) {
      return (this.index * -100) / this.DESKTOP_ITEMS;
    }
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
}



// WEBPACK FOOTER //
// ./src/components/slider/slider.js